export default __webpack_public_path__ + "static/media/erik.f0a04ea0.jpg";